import React from "react";
import { Editor } from 'react-draft-wysiwyg';
import { EditorState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';

import Button from './Button';
import TextInput from './TextInput';
import translateString from "../utils/Locales";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import './css/editor.css';

let t = translateString;

export default class SendNotificationWidget extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            editorState: EditorState.createEmpty(),
            subject: ''
        }
    }

    reset (){
        this.setState({
            editorState: EditorState.createEmpty(),
            subject: ''
        });
    }

    getText(state){
        var text = "";
        state.blocks && state.blocks.forEach(block => {
            text = text + block.text + '\n';
        });
        return text;
    }

    onContentStateChange = contentState => {

        this.savedEnabled = true;
        this.setState({ contentState});
       }

    render (){

        const that = this;
        return ( 

        <div style={{display: this.props.show == true ? 'block' : 'none'}}> 
            <div style={container} onClick={() => this.props.onClose()}>
            <div style={mainClass} onClick={(e) => e.stopPropagation()}>
                <div style={closeBtn} onClick={() => {
                    this.props.onClose();
                }}>
                    <img alt="" src={ require('../images/close_icon.png')} style={{ width: 30, height: 30, cursor: 'pointer' }} />
                </div>
                <div style={windowTitle}>{t('invia_notifica')}</div>
                <div style={{ display: 'flex', marginLeft: 5, marginBottom: 0, marginTop: -5 }}>
                    <img alt="" src={ require('../images/question_icon.png') } style={{ width: 10, height: 10, marginRight: 5, marginTop: 1 }} />
                    <p style={{ fontSize: 10, color: 'darkgray', maxWidth: '80%' }}>{t('notifica_info')}</p><br/>
                </div><br/>
                <div>{t('oggetto')}:</div>
                <TextInput name={''} value={this.state.subject} 
                    onChange={(text) => { this.setState({subject: text})}
                }/>
                <br/>
                <div style={{ marginLeft: 5 }}>{t('testo')}:</div>
                <div style={bodyMsg}>
                    <Editor
                            editorState={this.state.editorState}  
                            onContentStateChange={this.onContentStateChange}
                            onEditorStateChange={(editorState) => {
                                this.setState({
                                editorState
                                });
                            }}    
                            toolbarClassName="demo-toolbar-custom"
                            wrapperClassName="demo-wrapper"
                            editorClassName="demo-editor-custom"
                            toolbar={{
                                options: [],       
                                inline: {
                                    options: ['bold', 'italic', 'underline'],
                                    bold: { className: 'bordered-option-classname' },
                                    italic: { className: 'bordered-option-classname' },
                                    underline: { className: 'bordered-option-classname' },
                                },
                            }}
                        />
                </div>
                <br/>

                <Button callback={() => {
                    var bodyFull = draftToHtml(this.state.contentState);
                    var body = this.getText(this.state.contentState);
                    if (this.state.subject == "" || this.state.subject == undefined){
                        alert (t('errore_oggetto'));
                        return;
                    }

                    this.props.onSend(this.state.subject, body, bodyFull);
                }} title={t('invia')}></Button>
            </div>
            </div>
        </div>
        )
    }


}

const windowTitle = {
    color: 'darkgrey', 
    fontSize: 30, 
    fontWeight: 'bold', 
    fontFamily: 'Teko', 
    textAlign:'left', 
    marginLeft: 5, 
}

const mainClass = {
    position: 'absolute',
    top: '100px',
    left: '25%', 
    width: '50%',
    height: '540px',
    background: 'white',
    padding: '2%', 
    boxShadow: '0px 2px 10px darkgrey',
    borderRadius: '10px', 
    overflowX: 'hidden', 
    overflowY: 'scroll',
}

const container = {
    position: 'fixed', 
    display: 'block', 
    top: 0,
    left: 0, 
    bottom: 0, 
    right: 0,
    minWidth: '100%', 
    minHeight: '100%', 
    backgroundColor: '#3C3C3C4D',
    overflowX: 'hidden', 
    overflowY: 'scroll',
};

const bodyMsg = {
    border: '1px solid black',
    height: '200px',
    marginLeft: 5,
}

const closeBtn = {
    position: 'absolute',
    right: 10,
    top: 10,
    padding: 10, 
    zIndex: 999,
    cursor: 'pointer',
}